import { useTranslation } from 'react-i18next';

/**
 * " (optional)" after the label of a field that may stay empty (Component Map › Inputs: optional fields
 * say "(optional)"; required ones carry no star).
 */
export const OptionalMark = () => {
  const { t } = useTranslation();
  return <span className="font-normal text-muted-foreground"> {t('OPTIONAL_SUFFIX')}</span>;
};
